import { useResource, useResourceActions } from 'pulse/react';
import { ConversationsList } from './resource';
export const useConversationsListResource = ({
  agentId,
  limit = 20,
  offset,
  scope = 'OWN'
}) => {
  const params = {
    agentId,
    limit,
    offset,
    scope
  };
  const {
    data,
    loading,
    error
  } = useResource(ConversationsList, {
    params
  });
  const actions = useResourceActions();
  return {
    data,
    loading,
    error,
    invalidate: () => {
      actions.invalidate({
        resource: ConversationsList,
        params
      });
    }
  };
};